export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/refresh.c1447c7b.svg","height":16,"width":16};